import React, { useState, useEffect, useContext } from 'react';
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "app/components/Grid/GridItem.js";
import GridContainer from "app/components/Grid/GridContainer.js";
import Card from "app/components/Card/Card.js";
import CardHeader from "app/components/Card/CardHeader.js";
import CardBody from "app/components/Card/CardBody.js";
import CardFooter from "app/components/Card/CardFooter.js";
import axios from 'axios';
import FormCOL from "./FormCOLD.js";
import FormCO from "./FormCOD.js";
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Redirect, useLocation } from 'react-router';
import { darkBlueColor, whiteColor } from 'app/layout/material-dashboard-react.js';
import Button from "app/components/CustomButtons/Button.js";
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import Snackbar from "app/components/Snackbar/Snackbar.js";
import LockIcon from '@mui/icons-material/Lock';
import CircularProgress from '@mui/material/CircularProgress';
import { LoginStatusContext } from 'app/context/LoginStatusContext';

const urlCustomerOrder = `${process.env.REACT_APP_API_ENDPOINT}/api/customerOrder`;
const urlCustomerOrderLine = `${process.env.REACT_APP_API_ENDPOINT}/api/customerOrderLine`;

const styles = {
    cardCategoryWhite: {
        color: "rgba(255,255,255,.62)",
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        marginBottom: "0",
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
    },
    buttonStyling: {
        color: '#ffffff',
        width: '120px',
        padding: '5px',
        borderRadius: '5%'
    },
};

const useStyles = makeStyles(styles);

export default function CustomerOrderEdit() {
    const classes = useStyles();

    //usestate hooks - CO
    const [cOPostType, setCOPostType] = useState("update");
    const [showButtonContinueCO, setShowButtonContinueCO] = useState(true);
    const [showButtonEditCO, setShowButtonEditCO] = useState(false);
    const [disableInputCO, setDisableInputCO] = useState(false);
    const [customerOrderID, setCustomerOrderID] = useState(0);
    const [referenceID, setReferenceID] = useState("")
    const [contactName, setContactName] = useState("");
    const [requiredDate, setRequiredDate] = useState();
    const [customerReference, setCustomerReference] = useState("");
    const [dateAdded, setDateAdded] = useState();
    const [userAdded, setUserAdded] = useState("");
    const [accountID, setAccountID] = useState(0);
    const [customerSupplierID, setCustomerSupplierID] = useState(0);
    const [deliveryAddressID, setDeliveryAddressID] = useState(0);
    const [CODetails, setCODetails] = useState([]);
    const [accountName, setAccountName] = useState("");
    const [customerSupplierName, setCustomerSupplierName] = useState("");
    const [deliveryAddressName, setDeliveryAddressName] = useState("");
    const [customerSupplier, setCustomerSupplier] = useState("");
    const [externalSupplierID, setExternalSupplierID] = useState("");
    const [bookingID, setBookingID] = useState("");
    const [isLocked, setIsLocked] = useState(false);
    const [pendingSave, setPendingSave] = useState(false);

    //usestate hooks COL
    const [cOLPostType, setCOLPostType] = useState("");
    const [showButtonSaveCOL, setShowButtonSaveCOL] = useState(true);
    const [showButtonDeleteCOL, setShowButtonDeleteCOL] = useState(true);
    const [showFormCOL, setShowFormCOL] = useState(false);
    const [customerOrderLineID, setCustomerOrderLineID] = useState('');
    const [COLDetails, setCOLDetails] = useState([]);
    const [success, setSuccess] = useState(false)
    const [error, setError] = useState(false)
    const [isLockedSuccess, setIsLockedSuccess] = useState(false);
    const [isLockedError, setIsLockedError] = useState(false);

    //Determine Page
    sessionStorage.setItem('COD', true);

    //Other
    const location = useLocation();
    const params = new URLSearchParams(location.search);

    const { setIsLoggedIn } = useContext(LoginStatusContext);
    
    useEffect(() => {
        async function validateUserSessionId() {
            try {
                await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/api/login/ValidateUserSessionId`)
                        .then(() => setIsLoggedIn(true));
                
            } catch (error) {
                setIsLoggedIn(false);
                window.location.replace(`${process.env.PUBLIC_URL}/login`);
            }
        }
        validateUserSessionId();
    }, [setIsLoggedIn]);

    useEffect(() => {
        handleCODetails();
    }, []);

    function updateCO() {
        setCOPostType("update");
        setCOLPostType("");
    }

    function updateCOL() {
        setCOPostType("");
        setCOLPostType("update");
    }

    function deleteCOL() {
        setCOLPostType("delete");
        setCOPostType("delete");
    }

    function reset() {
        if (cOLPostType === "delete") {
            window.location.replace("/LeoSeaPortal/searchorder");
        }
    }

    function getIDs() {
        try {
            if (sessionStorage.getItem('COAccountID') !== null) {
                if (sessionStorage.getItem('COAccountID') !== 0) {
                    if (accountID === 0) {
                        setAccountID(sessionStorage.getItem('COAccountID'));
                    }
                }
            }

            if (sessionStorage.getItem('COCustomerSupplierID') !== null) {
                if (sessionStorage.getItem('COCustomerSupplierID') !== 0) {
                    setCustomerSupplierID(sessionStorage.getItem('COCustomerSupplierID'));
                }
            }

            if (sessionStorage.getItem('COCustomerSupplierID') !== null) {
                if (sessionStorage.getItem('COCustomerSupplierID') !== 0) {
                    setDeliveryAddressID(sessionStorage.getItem('CODeliveryAddressID'));
                }
            }
        }
        catch {
            console.log("CO: There was an issue with setting the ids")
        }
    }

    //Format date string
    function ProcessDate(date) {
        var shortDate = date.substring(0, date.indexOf('T'));
        var [YYYY, MM, DD] = shortDate.split('-');
        var formattedShortDate = new Date(YYYY, MM - 1, DD);
        var requiredGBDate = formattedShortDate.toLocaleDateString('en-GB');
        return requiredGBDate;
    }

    //Get address details
    function GetAddressName(id, addressOwner) {
        axios
            .get(`${process.env.REACT_APP_API_ENDPOINT}/api/address/GetAddressByID`, { params: { Id: id } })
            .then((res) => {
                if (res.length !== 0) {
                    if (addressOwner.toLowerCase() === "accountid") {
                        setAccountName(res.data[0].label);
                    }
                    if (addressOwner.toLowerCase() === "customersupplierid") {
                        sessionStorage.setItem('CODCustomerSupplierName', res.data[0].label);
                        setCustomerSupplierName(res.data[0].label);
                    }
                    if (addressOwner.toLowerCase() === "deliveryaddressid") {
                        sessionStorage.setItem('CODDeliveryAddressName', res.data[0].label);
                        setDeliveryAddressName(res.data[0].label);
                    }
                }
            })
            .catch((e) => {
                console.log('Customer Order Details Page has failed');
            });
    }

    //On load populate the customer order details
    const handleCODetails = () => {
        axios
            .get(`${process.env.REACT_APP_API_ENDPOINT}/api/customerorder/GetCustomerOrderByID`, { params: { COID: params.get("customerOrderId") } })
            .then((res) => {
                if (res.data.length !== 0) {
                    for (let i = 0; i < res.data.length; i++) {
                        //Required date to display correctly for country formats UK/China/Russia
                        var date = res.data[i].requiredDate;
                        //unformatted date for the Date picker to work.
                        res.data[i].requiredDateUnformatted = date;
                        var requiredDate = ProcessDate(date);
                        res.data[i].requiredDate = requiredDate;

                        //GetAddressDetails
                        GetAddressName(res.data[i].accountID, "accountid");
                        GetAddressName(res.data[i].customerSupplierID, "customersupplierid");
                        GetAddressName(res.data[i].deliveryAddressID, "deliveryaddressid");

                        sessionStorage.setItem('COCustomerSupplierID', res.data[i].customerSupplierID);
                        sessionStorage.setItem('CODeliveryAddressID', res.data[i].deliveryAddressID);

                        //set data in usestate for child components
                        setCODetails(res.data);

                        //set states
                        setReferenceID(res.data[i].reference);
                        setAccountID(res.data[i].accountID);
                        setContactName(res.data[i].contactName);
                        setCustomerReference(res.data[i].customerReference);
                        setCustomerSupplierID(res.data[i].customerSupplierID);
                        setCustomerSupplier(res.data[i].customerSupplier);
                        setExternalSupplierID(res.data[i].externalSupplierID);
                        setDeliveryAddressID(res.data[i].deliveryAddressID);
                        setRequiredDate(res.data[i].requiredDate);
                        setDateAdded(res.data[i].dateAdded);
                        setUserAdded(res.data[i].userAdded);
                        setCustomerOrderID(res.data[i].customerOrderID);
                        setBookingID(res.data[i].bookingID);
                        setIsLocked(res.data[i].isLocked);

                        //ETA date & ETD date
                        if (res.data[i].livePlan !== null) {
                            if (res.data[i].livePlan[0].estimatedArrivalDate !== null)
                            {
                                let formattedDate = ProcessDate(res.data[i].livePlan[0].estimatedArrivalDate);
                                res.data[i].livePlan[0].estimatedArrivalDate = formattedDate;
                            }
                        
                            if (res.data[i].livePlan[0].estimatedDepartureDate !== null)
                            {
                                let formattedDate = ProcessDate(res.data[i].livePlan[0].estimatedDepartureDate);
                                res.data[i].livePlan[0].estimatedDepartureDate = formattedDate;
                            }
                        }
                    }
                    //set data in usestate for child components
                    if (res.data[0].lines.length !== 0) {
                        setCOLDetails(res.data[0].lines);
                        let cOLIDs = "";
                        for (let i = 0; i < res.data[0].lines.length; i++) {
                            cOLIDs = cOLIDs + + res.data[0].lines[i].customerOrderLineID + ",";

                        }
                        setCustomerOrderLineID(cOLIDs);

                    }
                }

            })
            .catch((e) => {
                console.log('error happened');
            });
    };

    function handleIsLocked() {
        setIsLocked(true);
        const formDataJsonString = JSON.stringify({ customerOrderID: customerOrderID, isLocked: true });
        axios
            .post(
                `${process.env.REACT_APP_API_ENDPOINT}/api/customerOrder/SetIsLocked`, formDataJsonString)
            .then(function (response) {
                if (response !== null) {
                    if (response.status === 200 && response.data) {
                        setIsLockedSuccess(true);
                        setIsLockedError(false);

                        setTimeout(() => {
                            setIsLockedSuccess(false);
                        }, 5000)
                    }
                    else {
                        setIsLockedSuccess(false);
                        setIsLockedError(true);

                        setTimeout(() => {
                            setIsLockedError(false);
                        }, 5000)
                    }
                }
                else {
                    setIsLockedSuccess(false);
                    setIsLockedError(true);

                    setTimeout(() => {
                        setIsLockedError(false);
                    }, 5000)
                }
            })
            .catch(function (error) {
                console.log(error);
                setIsLockedSuccess(false);
                setIsLockedError(true);

                setTimeout(() => {
                    setIsLockedError(false);
                }, 5000)
            });
    }

    //form related
    const onSubmit = (e) => {
        setPendingSave(true);
        e.preventDefault();

        const form = e.currentTarget;
        var formData = new FormData(form);
        formData.append("CustomerOrderPostType", cOPostType);
        formData.append("accountID", accountID);
        formData.append("customerSupplierID", sessionStorage.getItem('COCustomerSupplierID'));
        formData.append("deliveryAddressID", sessionStorage.getItem('CODeliveryAddressID'));
        formData.append("customerOrderID", customerOrderID);
        formData.append("dateAdded", dateAdded);
        formData.append("userAdded", userAdded);
        formData.append("requiredDate", sessionStorage.getItem("CODRequiredDate"));
        formData.append("ReferenceID", referenceID);
        formData.append("CustomerOrderLinePostType", cOLPostType);
        formData.append("CustomerOrderLineID", customerOrderLineID);
        formData.append("contactName", sessionStorage.getItem("CODContactName"));
        formData.append("customerReference", sessionStorage.getItem("CODCustomerReference"));
        formData.append("deliveryAddressIDCO", sessionStorage.getItem('CODeliveryAddressID'));
        formData.append("COCustomerSupplierID", sessionStorage.getItem("COCustomerSupplierID"));
        formData.append("bookingSlot", sessionStorage.getItem("CODBookingSlot"));
        formData.append("ediReference", sessionStorage.getItem("CODEdiReference"));
        formData.append("sixDigitReference", sessionStorage.getItem("CODSixDigitReference"));
        formData.append("containerNumber", sessionStorage.getItem("CODContainerNumber"));
        formData.append("sealNumber", sessionStorage.getItem("CODSealNumber"));
        formData.append("customerSupplier", customerSupplier);
        formData.append("externalSupplierID", externalSupplierID);
        formData.append("bookingID", sessionStorage.getItem("CODBookingID"));
        formData.append("isLocked", isLocked);
        var plainFormData = Object.fromEntries(formData.entries());
        const formDataJsonString = JSON.stringify(plainFormData);

        //API
        TypeOfAPICall(cOPostType);

        function TypeOfAPICall(cOPostType) {

            if (cOPostType === "delete" || cOPostType === "update") {
                axios
                    .post(
                        urlCustomerOrder,
                        formDataJsonString
                    )
                    .then((response) => {
                        if (response !== null) {
                            if (response.status === 200) {
                                var variableInResponse = response.data.split(",");
                                if (variableInResponse.length === 15) {
                                    setReferenceID(variableInResponse[0]);
                                    setCustomerOrderID(Number(variableInResponse[1]));
                                    setAccountID(variableInResponse[2]);
                                    setCustomerSupplierID(variableInResponse[3]);
                                    setDeliveryAddressID(variableInResponse[4]);
                                    setContactName(variableInResponse[5]);
                                    setRequiredDate(variableInResponse[6]);
                                    setCustomerReference(variableInResponse[7]);
                                    setDateAdded(variableInResponse[8]);
                                    setUserAdded(variableInResponse[9]);
                                    setShowButtonContinueCO(false);
                                    setShowButtonEditCO(true);
                                    setDisableInputCO(true);
                                    setShowFormCOL(true);

                                    setSuccess(true);
                                    setError(false);

                                    setTimeout(() => {
                                        setSuccess(false)
                                    }, 5000)
                                }
                                reset();
                            }
                            else {
                                setSuccess(false);
                                setError(true);

                                setTimeout(() => {
                                    setError(false);
                                }, 5000)
                            }
                        }
                        else {
                            setSuccess(false);
                            setError(true);

                            setTimeout(() => {
                                setError(false);
                            }, 5000)
                        }
                        setPendingSave(false);
                    })
                    .catch(function (error) {
                        console.log(error + " posting to Customer Order");
                        setSuccess(false);
                        setError(true);

                        setPendingSave(false);

                        setTimeout(() => {
                            setError(false);
                        }, 5000)
                    });
            }
            if (cOLPostType === "update") {
                axios
                    .post(
                        urlCustomerOrderLine,
                        formDataJsonString
                    )
                    .then((response) => {
                        if (response !== null) {
                            if (response.status === 200) {
                                setCustomerOrderLineID(response.data);
                                try {
                                    let hasCommas = response.data.includes(',');
                                    if (hasCommas) {
                                        var separatedStringArray = response.data.split(',');
                                        for (let i = 0; i < separatedStringArray.length; i++) {
                                            if (separatedStringArray[i] !== '') {
                                                formData.append("CustomerOrderLineID" + i, separatedStringArray[i])
                                            }
                                        }
                                    }
                                }
                                catch {
                                    if (response.data !== '') {
                                        formData.append("CustomerOrderLineID" + 0, response.data)
                                    }
                                }
                                plainFormData = Object.fromEntries(formData.entries());
                                setShowButtonSaveCOL(true);
                                setShowButtonDeleteCOL(true);

                                setSuccess(true);
                                setError(false);

                                setTimeout(() => {
                                    setSuccess(false)
                                }, 5000)
                            }
                            else {
                                setSuccess(false);
                                setError(true);

                                setTimeout(() => {
                                    setError(false);
                                }, 5000)
                            }
                        }
                        else {
                            setSuccess(false);
                            setError(true);

                            setTimeout(() => {
                                setError(false);
                            }, 5000)
                        }
                        setPendingSave(false);
                    })
                    .catch(function (error) {
                        console.log(error + " posting to Customer Order Line");
                        setSuccess(false);
                        setError(true);

                        setPendingSave(false);

                        setTimeout(() => {
                            setError(false);
                        }, 5000)
                    });
            }
        }
    };

    return (
        <div id="CO">
            <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                    <Box sx={{ p: 2, display: 'flex' }}>
                        <Card>
                            <CardHeader style={{ backgroundColor: darkBlueColor, color: whiteColor }}>
                                <h4 className={classes.cardTitleWhite}>Customer Order Summary</h4>
                            </CardHeader>
                            <CardBody>
                                <GridContainer>

                                    {CODetails.map(item =>
                                        <GridItem xs={3}>
                                            <Typography fontWeight={700}>Europa Reference</Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                {item.reference}
                                            </Typography>
                                        </GridItem>
                                    )}
                                    {CODetails.map(item =>
                                        <GridItem xs={3}>
                                            <Typography fontWeight={700}>Account Holder</Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                {accountName}
                                            </Typography>
                                        </GridItem>
                                    )}
                                    {CODetails.map(item =>
                                        <GridItem xs={3}>
                                            <Typography fontWeight={700}>Contact Name</Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                {item.contactName}
                                            </Typography>
                                        </GridItem>
                                    )}
                                    {CODetails.map(item =>
                                        item.sourceTerminalLabel && <GridItem xs={3}>
                                            <Typography fontWeight={700}>Port of Loading</Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                {item.sourceTerminalLabel}
                                            </Typography>
                                        </GridItem>
                                    )}
                                </GridContainer>

                                <GridContainer>
                                    {CODetails.map(item =>
                                        <GridItem xs={3}>
                                            <Typography fontWeight={700}>Customer Supplier</Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                {customerSupplierName}
                                            </Typography>
                                        </GridItem>
                                    )}
                                    {CODetails.map(item =>
                                        <GridItem xs={3}>
                                            <Typography fontWeight={700}>Deliver Address</Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                {deliveryAddressName}
                                            </Typography>
                                        </GridItem>
                                    )}
                                    {CODetails.map(item =>
                                        <GridItem xs={3}>
                                            <Typography fontWeight={700}>Required Date</Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                {item.requiredDate}
                                            </Typography>
                                        </GridItem>
                                    )}
                                    {CODetails.map(item =>
                                        item.destinationTerminalLabel && <GridItem xs={3}>
                                            <Typography fontWeight={700}>Port of Discharge</Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                {item.destinationTerminalLabel}
                                            </Typography>
                                        </GridItem>
                                    )}

                                </GridContainer>

                                <GridContainer>
                                    {CODetails.map(item =>
                                        <GridItem xs={3}>
                                            <Typography fontWeight={700}>Purchase Order</Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                {item.customerReference}
                                            </Typography>
                                        </GridItem>
                                    )}
                                    {CODetails.map(item =>
                                        item.ediReference && (<GridItem xs={3}>
                                            <Typography fontWeight={700}>EDI Reference</Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                {item.ediReference}
                                            </Typography>
                                        </GridItem>
                                        ))}
                                    {CODetails.map(item =>
                                        item.sixDigitReference && (<GridItem xs={3}>
                                            <Typography fontWeight={700}>6 Digit Reference</Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                {item.sixDigitReference}
                                            </Typography>
                                        </GridItem>
                                        ))}
                                    {CODetails.map(item =>
                                        item.livePlan[0].vesselName && <GridItem xs={3}>
                                            <Typography fontWeight={700}>Vessel Name</Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                {item.livePlan[0].vesselName}
                                            </Typography>
                                        </GridItem>
                                    )}
                                </GridContainer>
                                <GridContainer>
                                    {CODetails.map(item =>
                                        item.bookingSlot && (<GridItem xs={3}>
                                            <Typography fontWeight={700}>Booking Slot</Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                {new Date(item.bookingSlot).toLocaleString('en-GB')}
                                            </Typography>
                                        </GridItem>
                                        ))}
                                    {CODetails.map(item =>
                                        item.containerNumber && (<GridItem xs={3}>
                                            <Typography fontWeight={700}>Container</Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                {item.containerNumber}
                                            </Typography>
                                        </GridItem>
                                        ))}
                                    {CODetails.map(item =>
                                        item.sealNumber && (<GridItem xs={3}>
                                            <Typography fontWeight={700}>Seal Number</Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                {item.sealNumber}
                                            </Typography>
                                        </GridItem>
                                        ))}
                                    {CODetails.map(item =>
                                        item.livePlan[0].estimatedArrivalDate && <GridItem xs={3}>
                                            <Typography fontWeight={700}>ETA</Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                {item.livePlan[0].estimatedArrivalDate}
                                            </Typography>
                                        </GridItem>
                                    )}
                                    {CODetails.map(item =>
                                        item.livePlan[0].estimatedDepartureDate && <GridItem xs={3}>
                                            <Typography fontWeight={700}>ETD</Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                {item.livePlan[0].estimatedDepartureDate}
                                            </Typography>
                                        </GridItem>
                                    )}
                                </GridContainer>

                                <Accordion style={{ marginTop: "40px" }}>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header" style={{ backgroundColor: "#2059A7", color: "#fff" }}>
                                        <Typography>Customer Order Lines</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <table className='table table-striped' id="ShipmentSearch" aria-labelledby="tabelLabel">
                                            <thead>
                                                <tr>
                                                    <th>Line Number</th>
                                                    <th>Item Code</th>
                                                    <th>Quantity</th>
                                                    <th>Description</th>
                                                    <th>Other Comments</th>
                                                    <th>Number Of Pallets</th>
                                                    <th>Units Per Pallet</th>
                                                    <th>Total Pieces</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {COLDetails.map(item =>
                                                    <tr key={item.customerOrderLineID}>
                                                        <td>{item.lineNumber}</td>
                                                        <td>{item.itemCode}</td>
                                                        <td>{item.quantity}</td>
                                                        <td>{item.description}</td>
                                                        <td>{item.rangeDescription}</td>
                                                        <td>{item.numberOfPallets}</td>
                                                        <td>{item.unitsPerPallet}</td>
                                                        <td>{item.totalPieces}</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </AccordionDetails>
                                </Accordion>
                            </CardBody>
                        </Card>
                    </Box>
                </GridItem>
            </GridContainer>

            <form onSubmit={onSubmit}>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader style={{ backgroundColor: darkBlueColor }}>
                                <h4 className={classes.cardTitleWhite}>{isLocked && <LockIcon/>} Europa Edit Customer Order {referenceID}</h4>
                            </CardHeader>
                            <CardBody>
                                <FormCO key={`form-col-$1`} disableInputCo={disableInputCO} CODetails={CODetails} />
                            </CardBody>
                            <CardFooter>
                                {showButtonContinueCO && (<Button type="submit" color="blue" onClick={getIDs}>Continue </Button>)}
                                {showButtonEditCO && (<Button type="submit" color="blue" onClick={updateCO}> Save Edit </Button>)}
                            </CardFooter>
                        </Card>
                    </GridItem>
                </GridContainer>
            </form>

            {showFormCOL && (
                <form onSubmit={onSubmit}>
                    <GridContainer>
                        <GridItem xs={12} sm={12}>
                            <Card>
                                <CardHeader style={{ backgroundColor: '#2059A7' }}>
                                    <h4 className={classes.cardTitleWhite}>Europa Edit Customer Order Lines {referenceID}</h4>
                                </CardHeader>
                                <CardBody>
                                    <FormCOL COLDetails={COLDetails} />
                                </CardBody>
                            </Card>
                        </GridItem>
                    </GridContainer>
                    <GridContainer>
                        <GridItem xs={12} sm={12}>
                            <Card>
                                <CardHeader>
                                    &nbsp;
                                </CardHeader>
                                <GridItem xs={12} sm={12}>
                                    {pendingSave && (<CircularProgress style={{ position: 'absolute', zIndex: '1', marginTop: 5, marginLeft: 45, color: '#FFF' }}></CircularProgress>)}
                                    {showButtonSaveCOL && (<Button type="submit" color="blue" disabled={pendingSave} onClick={updateCOL}> Save Edit </Button>)}&nbsp;
                                    {!isLocked && (<Button color="blue" disabled={pendingSave} onClick={handleIsLocked}> Lock </Button>)}&nbsp;
                                    {showButtonDeleteCOL && (<Button type="submit" color="blue" disabled={pendingSave} onClick={deleteCOL}> Delete All </Button>)}
                                </GridItem>
                                <CardFooter>
                                    {success && (<Alert severity="success">
                                        <AlertTitle>Customer Order Updated</AlertTitle>
                                    </Alert>)}
                                    {error && (<Alert severity="error">
                                        <AlertTitle>Error updating customer order</AlertTitle>
                                    </Alert>)}
                                    &nbsp;
                                    <Snackbar place="br" color="success" icon={CheckCircleIcon} message="Customer Order is now Locked!" open={isLockedSuccess}
                                        closeNotification={() => setIsLockedSuccess(false)} close />
                                    <Snackbar place="br" color="danger" icon={ErrorIcon} message="Customer Order failed to Lock!" open={isLockedError}
                                        closeNotification={() => setIsLockedError(false)} close />
                                </CardFooter>
                            </Card>
                        </GridItem>
                    </GridContainer>
                </form>
            )}
        </div>
    );
}